module.exports = __webpack_public_path__ + "static/media/favicon.33c9e54c.ico";